import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';
import { SpinnerService } from '@app/@shared/spinner/spinner.service';
import { UserService } from '@app/services/user.service';
import { ChangeDetectorRef } from '@angular/core';
import { ActivityService } from '@app/services';
import { Constant } from '@app/@core';
import { ActiveStatus } from '@app/interface/common';
import { StudyModel } from '@app/interface/study.model';
import { StudiesService } from '@app/services/studies.service';
@Component({
  selector: 'app-add-activity',
  templateUrl: './addEditActivity.component.html',
  styleUrls: ['./addEditActivity.component.scss'],
})
export class AddEditActivityComponent implements OnInit {
  activityForm: FormGroup;
  submitted = false;
  success: boolean;
  date = new Date().toISOString();
  isLoading = false;
  uploadedFiles: any[] = [];
  preview: string;
  status: Array<ActiveStatus> = Constant.ActiveStatus;

  @Input() title_tag: string;
  @Input() formType: string;
  @Input() form_data: any;

  studyDetail: StudyModel;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private cd: ChangeDetectorRef,
    private studiesService: StudiesService,
    private activeService: ActivityService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getstudyDetail();
  }

  private getstudyDetail(studyName?: string): void {
    this.studiesService.getStudyDetailById().subscribe((study) => {
      this.studyDetail = study;
    });
  }

  private createForm(): void {
    this.activityForm = this.formBuilder.group({
      uuid: [null],
      name: [null, [Validators.required()]],
      img: [null, [Validators.required()]],
      description: [null, [Validators.required()]],
      isActive: [false],
    });
    if (this.formType === 'Edit') {
      this.activityForm.patchValue(this.form_data);
    }
    this.preview = this.activityForm.get('img').value;
  }

  public onActivityUploadIcon(event: any): void {
    const reader = new FileReader();
    const [file] = event.target.files;
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.preview = reader.result as string;
      this.activityForm.patchValue({
        img: reader.result,
      });
    };
  }

  get formControl() {
    return this.activityForm.controls;
  }

  public save(): void {
    this.submitted = true;
    if (this.activityForm.valid) {
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateActivity(this.activityForm.value);
      } else {
        this.AddEditActivity(this.activityForm.value);
      }
    } else {
      return;
    }
  }

  private AddEditActivity(activityData: any): void {
    this.activeService.addDefaultActivity(activityData, this.studyDetail).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  private updateActivity(activityData: any): void {
    this.activeService.updateDefaultActivity(activityData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  private getRouteParmas(): void {
    this.studiesService.routeParams$.subscribe((params) => {
      if (params) {
        this.getstudyDetail(params.name);
      }
    });
  }
}
